<template>
  <v-container fluid>
    <v-row class="section" v-for="(datum, index) in command.data" :key="index">
      <v-col>
        <v-row>
          <v-col class="jobTitle">
            {{ datum.jobTitle }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="meta">
            🗓
            {{ datum.period.from }} - {{ datum.period.to }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="company">
            {{ datum.company }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="meta">
            🌍
            {{ datum.location }}
          </v-col>
        </v-row>
        <v-row class="techRow">
          <div v-if="datum.info">{{ datum.info }}</div>
          <div v-if="datum.technologies">
            Technologies: {{ datum.technologies }}
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'experience',
  props: ['command']
};
</script>

<style scoped>
.container {
  padding: 0;
  padding-bottom: 5px !important;
}

.section {
  border-bottom: 1px dashed white;
  padding-top: 20px;
}

.row {
  justify-content: center;
  margin: 0;
  margin-right: 8px;
}

.historyText {
  white-space: pre-line;
  padding-left: 10px;
  position: relative;
  top: -1px;
  max-width: 90%;
  word-break: break-word;
}

.col {
  text-align: left;
  padding: 5px 0;
}

.jobTitle {
  color: #009b64ba;
  font-size: 27px;
}

.meta {
  font-size: 22px;
  opacity: 0.8;
  text-align: right;
}

.company {
  padding: 0;
}

.techRow {
  flex-direction: column;
  justify-content: left;
}

@media only screen and (min-device-height: 300px) and (max-device-height: 600px) and (orientation: landscape) {
  .meta,
  .company,
  .techRow {
    font-size: 16px;
  }

  .jobTitle {
    font-size: 20px;
  }
  .section {
    padding-top: 10px;
  }
}

@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  .meta,
  .company,
  .techRow {
    font-size: 16px;
  }

  .jobTitle {
    font-size: 20px;
  }
  .section {
    padding-top: 10px;
  }
}
</style>
